import User from "../types/user";

export enum UserRoles {
  GlobalAdmin = 1,
  DetectorAdmin,
  DetectorUser,
  GmdAdmin,
  GmdUser,
  ResponderAdmin,
  ResponderUser,
  InvestigatorAdmin,
  InvestigatorAudit,
  InvestigatorManager,
  InvestigatorSpecialist,
  InvestigatorOfficer,
  AnyAdmin,
  AnyDetector,
}

const checkRole = (user: User, role: UserRoles): boolean => {
  const adminRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.DetectorAdmin,
  ];

  const detectorRoles: UserRoles[] = [
    UserRoles.GlobalAdmin,
    UserRoles.DetectorAdmin,
    UserRoles.DetectorUser,
  ];

  if (!user || !user.roles || user.roles.length < 1) return false;
  if (role === UserRoles.AnyAdmin)
    return !!user?.roles.find((x) => adminRoles.includes(x.id));
  if (role === UserRoles.AnyDetector)
    return !!user?.roles.find((x) => detectorRoles.includes(x.id));
  return !!user?.roles?.find((r) => r?.id === role);
};

export default checkRole;
